import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import LoginPage from '@/pages/LoginPage';
import Dashboard from '@/pages/Dashboard';
import PutAwayPage from '@/pages/PutAwayPage';
import PickingPage from '@/pages/PickingPage';
import CapacityPage from '@/pages/CapacityPage';
import InventoryPage from '@/pages/InventoryPage';
import LocationsPage from '@/pages/LocationsPage';
import ReplenishmentPage from '@/pages/ReplenishmentPage';
import TasksPage from '@/pages/TasksPage';
import HousekeepingPage from '@/pages/HousekeepingPage';
import PickingHistoryPage from '@/pages/PickingHistoryPage';
import UsersPage from '@/pages/UsersPage';
import ReportsPage from '@/pages/ReportsPage';
import MainLayout from '@/components/MainLayout';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('warehouse_token');
    const userData = localStorage.getItem('warehouse_user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    setUser(userData);
    localStorage.setItem('warehouse_token', token);
    localStorage.setItem('warehouse_user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('warehouse_token');
    localStorage.removeItem('warehouse_user');
  };

  if (loading) {
    return <div className="flex items-center justify-center h-screen bg-[#F4F4F5]">Loading...</div>;
  }

  return (
    <div className="App">
      <Toaster richColors position="top-right" closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={!user ? <LoginPage onLogin={handleLogin} /> : <Navigate to="/" />} />
          <Route path="/" element={user ? <MainLayout user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}>
            <Route index element={<Dashboard user={user} />} />
            <Route path="putaway" element={<PutAwayPage user={user} />} />
            <Route path="picking" element={<PickingPage user={user} />} />
            <Route path="capacity" element={<CapacityPage user={user} />} />
            <Route path="inventory" element={<InventoryPage user={user} />} />
            <Route path="locations" element={<LocationsPage user={user} />} />
            <Route path="replenishment" element={<ReplenishmentPage user={user} />} />
            <Route path="tasks" element={<TasksPage user={user} />} />
            <Route path="housekeeping" element={<HousekeepingPage user={user} />} />
            <Route path="picking-history" element={<PickingHistoryPage user={user} />} />
            <Route path="reports" element={<ReportsPage user={user} />} />
            <Route path="users" element={<UsersPage user={user} />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
